import * as actionTypes from '@store/actions/actionTypes';

const initialState = {
  data: {},
  legInfo: [
    {
      from: '',
      fromCode: null,
      to: '',
      toCode: null,
      date: null,
      time: '08:00',
      roundtrip: false,
      id: 1
    }
  ],
  aircraft: null,
  error: null,
  loading: false,
  accountName: '',
  contactEmail: '',
  passengers: [],
  pricingAllowed: false,
  passengerAllowed: false,
  summaryAllowed: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.QUOTING_SET_AIRCRAFT:
      return {
        ...state,
        aircraft: action.aircraft,
        passengerAllowed: true
      };
    case actionTypes.QUOTING_SET_SPECIFICATIONS:
      return {
        ...state,
        legInfo: action.legInfo
      };
    case actionTypes.QUOTING_SET_PASSENGERS:
      return {
        ...state,
        passengers: action.passengers,
        summaryAllowed: true
      };
    case actionTypes.QUOTING_START:
      return {
        ...state,
        error: null,
        loading: true
      };
    case actionTypes.QUOTING_RESET:
      return {
        data: {},
        legInfo: [
          {
            from: '',
            fromCode: null,
            to: '',
            toCode: null,
            date: null,
            time: '08:00',
            roundtrip: false,
            id: 1
          }
        ],
        aircraft: null,
        error: null,
        loading: false
      };
    case actionTypes.QUOTING_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.pricing,
        legInfo: action.payload.legInfo,
        pricingAllowed: true
      };
    case actionTypes.QUOTING_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case actionTypes.QUOTING_SUBMIT_START:
      return {
        ...state,
        error: null,
        loading: true
      };
    case actionTypes.QUOTING_SUBMIT_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false
      };
    case actionTypes.QUOTING_SUBMIT_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case actionTypes.QUOTING_SET_BOOKER_INFO:
      return {
        ...state,
        accountName: action.payload.accountName,
        contactEmail: action.payload.contactEmail
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/quoting.js